import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { set_logged_in, set_auth_token, set_menu_open } from 'store/actions';
import keycloak from 'keycloak';

const useLogout = () => {
  const dispatch = useDispatch();

  const logout = useCallback(() => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    dispatch(set_logged_in(false));
    dispatch(set_auth_token(''));
    dispatch(set_menu_open('tenants'));
    keycloak.logout({ redirectUri: window.location.origin });
  }, [dispatch]);

  return { logout };
};

export default useLogout;
